import postContent from './post-content';
import Utility from './utility';

const anchor = {};

anchor.currentUri = window.location;
anchor.init = () => {
  anchor.currentUri = window.location;
  anchor.makeAnchors();
  anchor.goToAnchor();
};

// -----------------------------------------------------------
// Create anchor tags for h1, h2 and h3 headers
// if they do not already exist
// -----------------------------------------------------------
anchor.makeAnchors = () => {
  const getH1s = document.querySelectorAll('h1,h2,h3,h4');
  if (getH1s.length > 0) {
    return (() => {
      Object.keys(getH1s).forEach((key) => {
        const value = getH1s[key];
        if ((typeof value !== 'undefined') && (typeof value.textContent !== 'undefined')) {
          if (!document.getElementsByName(Utility.slugify(value.textContent)).length) {
            getH1s[key].insertAdjacentHTML('beforebegin', `<a class="anchor" name="${Utility.slugify(value.textContent)}"></a>`)
          }
        }
      });
    })();
  }
  return null;
};

// -----------------------------------------------------------
// Find the hash in the url and go to the
// matching anchor on the page if it exists
// -----------------------------------------------------------
anchor.goToAnchor = () => {
  const hasHash = window.location.hash;
  if (hasHash) {
    // Only seek the anchor if it's in the post container
    const hash = document.querySelector(`${postContent.class} a[name="${hasHash.substr(1)}"]`);
    // if the hash anchor exist then move the page offset to the anchor
    if (hash) {
      return hash.scrollIntoView({ behavior: 'smooth' });
    }
  }
  return null;
};

export default anchor;

// -----------------------------------------------------------
// End resources/wp-content/themes/pbc2017/coffee/modules/anchor
